import { render, staticRenderFns } from "./physicalreport.vue?vue&type=template&id=0422edec&"
import script from "./physicalreport.vue?vue&type=script&lang=js&"
export * from "./physicalreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports